import versions from './media-versions.json';

/** Retained captures keep their filenames until fresh captures use the current platform ID. */
export function sampleMediaId(id: string): string {
  if (id in versions) return id;
  if (id.startsWith('camera-uav-')) return id.replace('camera-uav-', 'camera-overview-');
  const capturedMapIds = { mcnally: 'bright', heat: 'elevation', 'moon-base': 'dark-relief', terra: 'satellite' };
  for (const [current, captured] of Object.entries(capturedMapIds)) {
    if (id === `map-${current}`) return `map-${captured}`;
    if (id.startsWith(`cover-${current}-`)) return id.replace(`cover-${current}-`, `cover-${captured}-`);
  }
  return id;
}
